import { createTranslations } from '../../i18n/types';

/**
 * Labels for buttons the caller passes without text — `{ type: 'cancel' }`,
 * `{ type: 'ok' }`, `{ type: 'close' }`. In Telegram those come localized from
 * the client; outside it they are ours to write.
 */
export default createTranslations({
  en: {
    cancel: 'Cancel',
    ok: 'Got it',
    close: 'Close',
  },
  ru: {
    cancel: 'Отмена',
    ok: 'Понятно',
    close: 'Закрыть',
  },
  uz: {
    cancel: 'Bekor qilish',
    ok: 'Tushunarli',
    close: 'Yopish',
  },
  fa: {
    cancel: 'بی‌خیال',
    ok: 'باشه',
    close: 'بستن',
  },
});
